import graphqlFetch from '@helpers/api/graphql-fetch';
import { generateUrlWithQueryParameter, REMOVE_FALSY } from '@helpers/url';
import { gql } from 'graphql-request';
import { sectionHighlighBannerContentGql } from '../visual-blocks/sectionHighlightBanner';

const VALID_STATUS = [200];

export async function getHighlightBannerConfigData({
  preview = false,
  bannerPage,
}: {
  preview?: boolean;
  bannerPage: string;
}): Promise<any> {
  const dataGql = gql`
    query HighlightBannerConfiguration {
      highlightBannerConfiguration {
        ${bannerPage} {
          ${sectionHighlighBannerContentGql}
        }
      }
    }
  `;

  try {
    const {
      highlightBannerConfiguration: { [bannerPage]: highlightBanner },
    } = await graphqlFetch(dataGql, {
      preview,
    });

    const { startDate, endDate, clockActive } = highlightBanner;

    const date = new Date().toISOString();
    const hasClock = clockActive && startDate <= date && date <= endDate;

    return { highlightBanner: { ...highlightBanner, clockActive: hasClock } };
  } catch {
    return { highlightBanner: null };
  }
}

export async function getServerlessHighlightBannerConfigData({
  preview = false,
  bannerPage,
}: {
  preview?: boolean;
  bannerPage: string;
}): Promise<any> {
  try {
    const domain = typeof window === 'undefined' ? process.env.NEXT_PUBLIC_HTTP_DOMAIN : '';

    const url = generateUrlWithQueryParameter(
      `${domain}/api/datocms/highlight-banner`,
      {
        preview,
        bannerPage,
      },
      REMOVE_FALSY
    );

    const response = await fetch(url);

    if (!VALID_STATUS.includes(response.status)) {
      throw new Error(`Invalid response status ${response.status}`);
    }

    return await response.json();
  } catch (e) {
    return getHighlightBannerConfigData({ preview, bannerPage });
  }
}
